import { Stack } from "@mui-wrapper";
import { AppBar } from "@flat-ui";
import { DevFeaturesDialogButton } from "@components/dev-features-dialog/dev-features-dialog-button";
import { useLoggedInUser } from "@hooks/use-logged-in-user";
import { CreateWorkspace } from "@components/create-workspace";
import { UserMenuDropdown } from "@components/navbar/user-menu";
import { SubjectBreadcrumbs } from "@components/subject-breadcrumbs";
import { AppRegionButton } from "@components/navbar/app-region-button";
import { ThemeModeToggle } from "@components/navbar/theme-mode-toggle";

export function NavBar(): React.JSX.Element {
  const { currentUser, currentUserRoles } = useLoggedInUser();

  return (
    <AppBar shouldShowLogo={false} shouldShowDivider={false}>
      <Stack
        direction="row"
        sx={{
          flex: 1,
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <SubjectBreadcrumbs />

        <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
          <CreateWorkspace />

          <ThemeModeToggle />

          <DevFeaturesDialogButton currentUserRoles={currentUserRoles} />

          <AppRegionButton />

          {currentUser && <UserMenuDropdown currentUser={currentUser} />}
        </Stack>
      </Stack>
    </AppBar>
  );
}
